import { TReduxActions } from '../../actions';
import { EFeaturesActionType } from '../../actions/features';
import { ESearchResultsActionType } from '../../actions/searchResults';
import { TFeatureWithPrecision } from '../../types/map';

const initialState: TFeatureWithPrecision | null = null;

export function activeFeatureReducer(
  state: TFeatureWithPrecision | null = initialState,
  action: TReduxActions,
): TFeatureWithPrecision | null {
  switch (action.type) {
    case EFeaturesActionType.FeatureSelected:
      return action.payload;
    case ESearchResultsActionType.SidebarClosed:
      return initialState;
  }

  return state;
}
